import React, { useCallback, useState } from "react"
import Typography from "@mui/material/Typography"
// import logo from '../assets/images/logo.svg';
import { useInfoStore } from "../store/userInfo";
import { useLongPress } from "use-long-press";
import { Box, Portal, Stack } from "@mui/material";
import { isBrowser } from 'react-device-detect';
import SignOut from "./SignOut";
import { useAppKey } from "../context/AppKeyContext";
import { logger } from "../utils/logger";

const Logo = React.memo(() => {
  const { userInfo, loginMode } = useInfoStore();
  const [openSignOut, setOpenSignOut] = useState(false)
  const { refreshApp } = useAppKey();
  const mode = process.env.REACT_APP_MODE

  // console.log(mode)

  // const refreshCallback = useCallback(() => {
  //   console.log('refreshApp - long press detected')
  //   refreshApp();
  //   // 브라우저에서도 테스트할 수 있도록 로그 추가
  //   if (isBrowser) {
  //     console.log('Browser environment - refreshing app')
  //   } else if (typeof window !== "undefined") {
  //     console.log('Native environment - sending imageReload message')
  //     if(window.Android !== undefined) {
  //       window.Android.postMessage(JSON.stringify({'type': 'imageReload'}));
  //     }
  //   }
  // },[refreshApp]);  // refreshApp을 의존성 배열에 추가

  const handleReloading = () => {
    logger.debug('handleReloading')
    if(typeof window !== "undefined" && !isBrowser){
      if(window.ReactNativeWebView !== undefined) {
        logger.debug('window.ReactNativeWebView !== undefined')
       window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'reload'}));
      } else if(window.Android !== undefined) {
       window.Android.postMessage(JSON.stringify({'type': 'reload'}));
      //  window.Android.postMessage(JSON.stringify({'type': 'imageReload'}));
     }
    }
  }

  const refresh = useLongPress(handleReloading, {
    threshold: 200,
    cancelOnMovement: 40,
    cancelOutsideElement: false,
  })
  
  const signoutCallback = useCallback(() => {
    setOpenSignOut(true)
  },[]);

  const signout = useLongPress(signoutCallback, {
    threshold: 2000,
    cancelOnMovement: 40,
    cancelOutsideElement: false,
  })

  return (
    <>
    <Box sx={{display: 'flex', flexDirection: 'column', justifyContent:'center', alignItems: 'center'}}>
      <Stack sx={{ justifyContent:'flex-start', alignItems: 'center', height: '16rem', width: '100%'}} >
        {/* <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '100%'}}>
          <Typography sx={{textAlign: 'center', color: '#000', border: '1.5px solid #000', borderRadius: '5px', padding: '0px 10px'}}>{packageJson.version}</Typography>
        </Box> */}
        <Box 
          sx={{
            display: 'flex', 
            flexDirection: 'row', 
            justifyContent: 'center', 
            alignItems: 'flex-end', 
            marginTop: '2.0rem',
            cursor: 'pointer',
            WebkitTapHighlightColor: 'transparent',
            touchAction: 'none'
          }} 
          {...refresh()}
          data-login-mode={loginMode}
          onClick={(e) => e.preventDefault()}
        >
          <img style={{alignSelf: 'center', width: '6.66rem', height: '5.59rem'}}
            src={process.env.PUBLIC_URL+'/assets/images/logo.svg'}
            alt="logo"
          />
          {mode === 'Dev' ? <Typography sx={{color: '#fff', background: '#000', borderRadius: '.5rem', px: '.5rem', fontWeight: '700', ml: '.5rem'}}>{mode}</Typography> : <></>}
        </Box>
        <Typography sx={{ fontSize: '1.6rem', fontWeight: '700', height: '6rem', letterSpacing: '-.02rem', padding: '1rem 1.7rem', width: '22rem', paddingBottom: '1.4rem',
            lineClamp: 2, wordWrap: 'break-word', boxOrient: "vertical",  textAlign: 'center'}} {...signout()} data-login-mode={loginMode}>{userInfo?.storeName}</Typography>
      </Stack>
    </Box>
    <Portal>
      <SignOut openSignOut={openSignOut} setOpenSignOut={setOpenSignOut} />
    </Portal>
    </>
  )
});

export default Logo
